import { themeAtom } from "../../shared/atoms";
import { formatDate } from "../../shared/services/utils";
import { TechForm } from "../models/tech-form.model";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

interface Props {
  forms: { tech?: TechForm[]; baltic?: TechForm[] };
  openCompletedTechForm: (techForm: TechForm) => void;
}

export const TechFormsCompleted: React.FC<Props> = ({ forms, openCompletedTechForm }) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div className={twMerge("h-80 overflow-auto rounded-lg py-4", theme.certVesselSelect.tableBg)}>
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr
              className={twMerge("border", theme.myVesselsTable.tailwind.tableBorder, theme.home.tailwind.textDefault)}
            >
              <th className="h-14 px-4 py-2 text-left text-xs font-semibold">Request</th>
              <th className="h-14 px-4 py-2 text-left text-xs font-semibold">Request on</th>
              <th className="h-14 px-4 py-2 text-left text-xs font-semibold">Submitted on</th>
              <th className="h-14 px-4 py-2 text-left text-xs font-semibold"></th>
            </tr>
          </thead>
          <tbody>
            {forms?.tech?.map((form, index) => (
              <FormItem
                key={(form as any)?.id ?? `tech-${index}`}
                index={index}
                form={form}
                isLast={index === (forms?.tech?.length || 0) - 1}
                openCompletedTechForm={openCompletedTechForm}
              />
            ))}

            {forms?.baltic?.map((form, index) => (
              <FormItem
                key={(form as any)?.id ?? `baltic-${index}`}
                index={index}
                form={form}
                isLast={index === (forms?.baltic?.length || 0) - 1}
                openCompletedTechForm={openCompletedTechForm}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

type ItemProps = {
  index: number;
  form: TechForm;
  isLast: boolean;
  openCompletedTechForm: (techForm: TechForm) => void;
};

function FormItem({ index, form, isLast, openCompletedTechForm }: ItemProps) {
  const theme = useAtomValue(themeAtom);
  return (
    <tr
      key={index}
      className={twMerge("border", theme.myVesselsTable.tailwind.tableBorder, theme.home.tailwind.textDefault)}
    >
      {/* Skipped number, only one usually */}
      {/* <td className="h-14 px-4 py-2 text-xs">Technical form #{index + 1}</td> */}
      <td className="h-14 px-4 py-2 text-xs">{form.TYPE === "TECH" ? "Technical" : "Baltic"} form</td>
      <td className="h-14 px-4 py-2 text-xs">{formatDate(form.REQUESTED_ON)}</td>
      <td className="h-14 px-4 py-2 text-xs">{formatDate(form.SUBMITTED_ON)}</td>
      <td className="h-14 px-4 py-2 text-xs">
        {isLast && (
          <p onClick={() => openCompletedTechForm(form)} className="text-green" style={{ cursor: "pointer" }}>
            Edit
          </p>
        )}
      </td>
    </tr>
  );
}
